import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

const initialState = {
  addDrawerOpen: false,
  removeDrawer: {
    isOpen: false,
    employees: [],
  },
};

export const reviewMemberModification = createSlice({
  name: 'reviewMemberModification',
  initialState,
  reducers: {
    openAddDrawer: (state) => {
      state.addDrawerOpen = true;
    },
    closeAddDrawer: (state) => {
      state.addDrawerOpen = false;
    },
    openRemoveDrawer: (state, action) => {
      state.removeDrawer.isOpen = true;
      state.removeDrawer.employees = action.payload;
    },
    closeRemoveDrawer: (state) => {
      state.removeDrawer.isOpen = false;
      state.removeDrawer.employees = [];
    },
  },
});

export const { openAddDrawer, closeAddDrawer, openRemoveDrawer, closeRemoveDrawer } = reviewMemberModification.actions;

export default reviewMemberModification.reducer;

export const useReviewMemberModificationState = () => useSelector((state) => state.reviewMemberModification);
